import "./InstructorSection.scss";

function InstructorSection({
  tag,
  tagIcon,
  title1,
  title2,
  description,
  description2,
  benefits = [],
  image,
  imageAlt = "",
  reversed = false,
  actions,
  className = "",
  citation = [],
}) {
  return (
    <section
      className={`instructor ${reversed ? "instructor--reversed" : ""} ${className}`}
    >
      <div className="instructor__container">
        <div className="instructor__content">
          {tag && (
            <span className="instructor__tag">
              {tagIcon && (
                <span className="instructor__tag-icon">{tagIcon}</span>
              )}{" "}
              {tag}
            </span>
          )}
          {title1 && <h2 className="instructor__title">{title1}</h2>}
          {title2 && <h2 className="instructor__title">{title2}</h2>}
          {description && (
            <p className="instructor__description">{description}</p>
          )}

          {benefits.length > 0 && (
            <ul className="instructor__benefits">
              {benefits.map((benefit, i) => (
                <li key={i} className="instructor__benefit">
                  {benefit.icon && (
                    <span className="instructor__benefit-icon">
                      {benefit.icon}
                    </span>
                  )}
                  <div className="instructor__benefit-content">
                    <span className="instructor__benefit-text">
                      {benefit.text}
                    </span>
                    <span className="instructor__benefit-description">
                      {Array.isArray(benefit.description)
                        ? benefit.description.map((desc, j) => (
                            <div key={j}>{desc}</div>
                          ))
                        : benefit.description}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
          {description2 && (
            <p className="instructor__description">{description2}</p>
          )}

          {actions && <div className="instructor__actions">{actions}</div>}
        </div>

        <div className="instructor__image-wrapper">
          {image ? (
            <img src={image} alt={imageAlt} className="instructor__image" />
          ) : (
            <div className="instructor__image-placeholder">Obrázok</div>
          )}
          {citation.length > 0 && (
            <div className="instructor__image-citation">
              {citation?.map((c, i) => (
                <span key={i}>{c}</span>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default InstructorSection;
